
import React, { useState } from 'react'
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap'

/**
 * LocationPopover - Hover popup showing location details with address and contact.
 * BRD: "Window pop up to show physical location with a contact number"
 * Format: Dealer Name, Street Address, City/Province/Postal, Phone
 */
const LocationPopover = ({ 
	id, 
	location, 
	locationName,  // Dealer name (e.g., "VOLVO CARS MONT-ROYAL")
	address, 
	city, 
	province, 
	postalCode, 
	contactName, 
	contactPhone,
	children 
}) =>
{
	const [isOpen, setIsOpen] = useState(false)

	const togglePopover = () => setIsOpen(!isOpen)

	// Format: City, Province PostalCode (e.g., "MONT-ROYAL, QC H4P 2T9")
	const cityProvincePostal = [
		[city, province].filter(Boolean).join(', '),
		postalCode
	].filter(Boolean).join(' ')

	const hasDetails = locationName || address || cityProvincePostal || contactPhone

	if (!hasDetails)
	{
		return children || <span>{location || '—'}</span>
	}

	return (
		<>
			<span
				id={id}
				style={{ 
					color: '#007bff', 
					cursor: 'pointer', 
					textDecoration: 'underline',
					borderBottom: '1px dotted #007bff'
				}}
				onMouseEnter={() => setIsOpen(true)}
				onMouseLeave={() => setIsOpen(false)}
			>
				{children || location || '—'}
			</span>
			<Popover
				placement="right"
				isOpen={isOpen}
				target={id}
				toggle={togglePopover}
			>
				<PopoverHeader>Vehicle Location</PopoverHeader>
				<PopoverBody>
					{/* BRD format: Dealer Name, Address, City/Province/Postal, Phone */}
					{locationName && (
						<div className="fw-bold mb-1">{locationName}</div>
					)}
					{address && (
						<div>{address}</div>
					)}
					{cityProvincePostal && (
						<div>{cityProvincePostal}</div>
					)}
					{contactPhone && (
						<div className="mt-1">
							<a href={`tel:${contactPhone}`}>{contactPhone}</a>
						</div>
					)}
				</PopoverBody>
			</Popover>
		</>
	)
}

export default LocationPopover
